import { useOutletContext } from "react-router-dom";
import { Link } from "react-router-dom";
import { formatDate } from "../services/helpers";

export function VehicleDetailsServices(){
	const contextData = useOutletContext();
	const history = contextData.services.history;

	return (<>
	{history.length === 0 && <h1>No Service history found</h1>}
	<table>
			<thead>
				<th>Service Date</th>
				<th>Service Tag</th>
				<th>Invoice Total</th>
				<th>Status</th>
				<th>Actions</th>
			</thead>
			<tbody>
				{history.map(service=>
					<tr>
						<td>{formatDate(service.date_created,false)}</td>
						{/* <td>Last Updated: {formatDate(service.date_updated)}</td> */}
						<td>{service.tag_name ?? "n/a"}</td>
						<td>GHS {service.total_bill}</td>
						<td><span className={`status-card ${service.status?.replaceAll(" ","-")}`}>{service.status}</span></td>
						<td>
							<div className="action-section col">
								<Link className="red-text" to={`/dashboard/services/${service.license_plate}/${service.ticket_id}`}>Details </Link>
							</div>
						</td>
					</tr>
				)}
			</tbody>
		</table>
		{/* {history.map((service,index) => <div className="info-tile" key={index}>
			<div className="image-section">
				<img src="https://avatar.iran.liara.run/public/43" alt="" />
			</div>
			<div className="primary-info-section">
				<b> Status: {service.status}</b>
				{
				// <p> {service.item_count} Invoice Item{service.item_count >1 ? "s" : ""}</p>
				}
			</div>
			<div className="secondary-info-section">
				<p>Date Added: {formatDate(service.date_created)}</p>
				{// <p>Last Updated: {formatDate(service.date_updated)}</p>
				}
				{// <p>Subscription Expiry/: </p>
					}
			</div>
			<div className="action-section col">

				{// <Link className="blue-text" to="/dashboard/members/u/4">Message </Link>
				}
			</div>
		</div>)}
		</>) */}
	</>);
}